'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _d2 = require('d3');

var d3 = _interopRequireWildcard(_d2);

var _reactMeasure = require('react-measure');

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _utils = require('./utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var maxPos = _utils.chromosomesWithCumulativeLengths[_utils.chromosomesWithCumulativeLengths.length - 1].cumulativeLength;

var totalLength = _utils.chromosomesWithCumulativeLengths.reduce(function (acc, ch) {
  return acc + ch.length;
}, 0);

var getXTicks = function getXTicks(x) {
  var _x$domain = x.domain(),
      _x$domain2 = _slicedToArray(_x$domain, 2),
      start = _x$domain2[0],
      end = _x$domain2[1];

  var chRange = findChRange(x.domain());

  if (chRange.length === 1) {
    return [start, (start + end) / 2];
  }

  var ticks = [];
  ticks.push(start);
  ticks.push((start + chRange[0].cumulativeLength) / 2);

  for (var i = 1; i < chRange.length - 1; i++) {
    var chromosome = chRange[i];
    ticks.push(chromosome.cumulativeLength - chromosome.length);
    ticks.push(chromosome.cumulativeLength - chromosome.length / 2);
  }

  var lastCh = chRange[chRange.length - 1];
  ticks.push(lastCh.cumulativeLength - lastCh.length);
  ticks.push((lastCh.cumulativeLength - lastCh.length + end) / 2);

  return ticks;
};

var getX2Ticks = function getX2Ticks() {
  var ticks = [];
  _utils.chromosomesWithCumulativeLengths.forEach(function (ch) {
    var chStart = ch.cumulativeLength - ch.length;
    var chMiddle = chStart + ch.length / 2;
    ticks.push(chStart);
    ticks.push(chMiddle);
  });

  return ticks;
};

var findChRange = function findChRange(range) {
  var _range = _slicedToArray(range, 2),
      start = _range[0],
      end = _range[1];

  var chStart = _utils.chromosomesWithCumulativeLengths.findIndex(function (ch) {
    return ch.cumulativeLength - ch.length <= start && start < ch.cumulativeLength;
  });
  var chEnd = _utils.chromosomesWithCumulativeLengths.findIndex(function (ch) {
    return ch.cumulativeLength - ch.length < end && end <= ch.cumulativeLength;
  });

  var chRange = [];
  for (var i = chStart; i <= chEnd; i++) {
    chRange.push(_utils.chromosomesWithCumulativeLengths[i]);
  }

  return chRange;
};

var getChromosomeName = function getChromosomeName(pos) {
  var chromosome = _utils.chromosomesWithCumulativeLengths.find(function (ch) {
    return ch.cumulativeLength - ch.length <= pos && pos < ch.cumulativeLength;
  });
  return chromosome.name;
};

var OUTER_HEIGHT = 430;
var OUTER_HEIGHT2 = 95;

var margin = { top: 20, right: 20, bottom: 30, left: 80 };
var margin2 = { top: 20, right: 20, bottom: 30, left: 80 };

var height = OUTER_HEIGHT - margin.top - margin.bottom;
var height2 = OUTER_HEIGHT2 - margin2.top - margin2.bottom;

var x2Ticks = getX2Ticks();

var customXAxis = function customXAxis(g, axis) {
  g.call(axis);
  g.selectAll('.tick:nth-child(odd) line').remove();
  g.selectAll('.tick:nth-child(even) text').remove();
  g.selectAll('.tick text').attr('fill', _theme2.default.axis.color).attr('font-size', 12);
  g.selectAll('.domain, .tick line').attr('stroke', _theme2.default.axis.color);
};

var customYAxis = function customYAxis(g, axis) {
  g.call(axis);
  g.selectAll('.tick text').attr('fill', _theme2.default.axis.color);
  g.selectAll('.domain, .tick line').attr('stroke', _theme2.default.axis.color);
};

var ManhattanPlot = function (_Component) {
  _inherits(ManhattanPlot, _Component);

  function ManhattanPlot() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ManhattanPlot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ManhattanPlot.__proto__ || Object.getPrototypeOf(ManhattanPlot)).call.apply(_ref, [this].concat(args))), _this), _this.svg = _react2.default.createRef(), _this.svg2 = _react2.default.createRef(), _this.clip = _react2.default.createRef(), _this.sigLine = _react2.default.createRef(), _this.brushRef = _react2.default.createRef(), _this.xAxisRef = _react2.default.createRef(), _this.yAxisRef = _react2.default.createRef(), _this.x2AxisRef = _react2.default.createRef(), _this.x = d3.scaleLinear().domain([0, totalLength]), _this.x2 = d3.scaleLinear().domain([0, totalLength]), _this.y = d3.scaleLinear().range([height, 0]), _this.y2 = d3.scaleLinear().range([height2, 0]), _this.xAxis = d3.axisBottom(_this.x).tickFormat(function (d) {
      return getChromosomeName(d);
    }), _this.yAxis = d3.axisLeft(_this.y), _this.x2Axis = d3.axisBottom(_this.x2).tickValues(x2Ticks).tickFormat(function (d, i) {
      return _utils.chromosomeNames[Math.floor(i / 2)];
    }), _this.brush = d3.brushX(), _this.zoom = d3.zoom().scaleExtent([1, Infinity]), _this.state = {
      open: false,
      anchorEl: null,
      anchorData: []
    }, _this.brushed = function () {
      if (d3.event.sourceEvent && d3.event.sourceEvent.type === 'zoom') return;

      var width = _this._outerWidth() - margin.left - margin.right;
      var selection = d3.event.selection || _this.x2.range();

      var _selection$map = selection.map(_this.x2.invert, _this.x2),
          _selection$map2 = _slicedToArray(_selection$map, 2),
          start = _selection$map2[0],
          end = _selection$map2[1];

      start = start < 0 ? 0 : start;
      end = end > maxPos ? maxPos : end;
      _this.x.domain([start, end]);

      // close tooltip when brushing
      _this.setState({ open: false });

      d3.select(_this.svg.current).select('.focus').selectAll('rect').attr('x', function (d) {
        return _this.x(d.globalPosition);
      });

      // update ticks of xAxis
      _this.xAxis.tickValues(getXTicks(_this.x));
      d3.select(_this.xAxisRef.current).call(customXAxis, _this.xAxis);

      d3.select(_this.svg.current).call(_this.zoom.transform, d3.zoomIdentity.scale(width / (selection[1] - selection[0])).translate(-selection[0], 0));

      _this.props.onZoom(start, end);
    }, _this.zoomed = function () {
      if (d3.event.sourceEvent && d3.event.sourceEvent.type === 'brush') return;

      var transform = d3.event.transform;

      var _transform$rescaleX$d = transform.rescaleX(_this.x2).domain(),
          _transform$rescaleX$d2 = _slicedToArray(_transform$rescaleX$d, 2),
          start = _transform$rescaleX$d2[0],
          end = _transform$rescaleX$d2[1];

      start = start < 0 ? 0 : start;
      end = end > maxPos ? maxPos : end;
      _this.x.domain([start, end]);

      // close tooltip when zooming
      _this.setState({ open: false });

      var svg = d3.select(_this.svg.current);
      var svg2 = d3.select(_this.svg2.current);

      svg.select('.focus').selectAll('rect').attr('x', function (d) {
        return _this.x(d.globalPosition);
      });

      _this.xAxis.tickValues(getXTicks(_this.x));
      d3.select(_this.xAxisRef.current).call(customXAxis, _this.xAxis);

      svg2.select('.context').select('.brush').call(_this.brush.move, _this.x.range().map(transform.invertX, transform));

      _this.props.onZoom(start, end);
    }, _this.handleMouseLeave = function () {
      _this.setState({ open: false, anchorEl: null, anchorData: [] });
    }, _this.handleMouseOver = function (anchorEl, data) {
      var _this$props = _this.props,
          tableColumns = _this$props.tableColumns,
          studyId = _this$props.studyId;

      var anchorData = tableColumns(studyId).map(function (_ref2) {
        var id = _ref2.id,
            label = _ref2.label,
            renderCell = _ref2.renderCell;

        return {
          label: label,
          value: renderCell ? renderCell(data) : data[id]
        };
      });
      _this.setState({ anchorEl: anchorEl, open: true, anchorData: anchorData });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ManhattanPlot, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.brush.on('brush end', this.brushed);
      this.zoom.on('zoom', this.zoomed);
      this._render(this.handleMouseOver);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.brush.on('brush end', null);
      this.zoom.on('zoom', null);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.associations !== prevProps.associations || this.props.contentRect.bounds.width !== prevProps.contentRect.bounds.width) {
        this._render(this.handleMouseOver);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          measureRef = _props.measureRef,
          ListTooltip = _props.listTooltip;

      var outerWidth = this._outerWidth();

      return _react2.default.createElement(
        'div',
        { ref: measureRef, onMouseLeave: this.handleMouseLeave },
        _react2.default.createElement(
          'svg',
          {
            xmlns: 'http://www.w3.org/2000/svg',
            ref: this.svg,
            width: outerWidth,
            height: OUTER_HEIGHT,
            cursor: 'move'
          },
          _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement(
              'clipPath',
              { id: 'clip' },
              _react2.default.createElement('rect', { ref: this.clip, height: height })
            )
          ),
          _react2.default.createElement(
            'g',
            {
              className: 'focus',
              transform: 'translate(' + margin.left + ', ' + margin.top + ')',
              clipPath: 'url(#clip)'
            },
            _react2.default.createElement('line', { ref: this.sigLine, x1: '0', stroke: _theme2.default.secondary })
          ),
          _react2.default.createElement('g', {
            ref: this.xAxisRef,
            transform: 'translate(' + margin.left + ', ' + (OUTER_HEIGHT - margin.bottom) + ')',
            fontSize: '12'
          }),
          _react2.default.createElement('g', {
            ref: this.yAxisRef,
            transform: 'translate(' + margin.left + ', ' + margin.top + ')'
          }),
          _react2.default.createElement(
            'text',
            {
              x: '40',
              y: '200',
              transform: 'rotate(-90 40,200)',
              fontFamily: 'sans-serif',
              fontSize: '12',
              fill: _theme2.default.axis.color
            },
            '-log\u2081\u2080(p-value)'
          ),
          _react2.default.createElement(ListTooltip, {
            open: this.state.open,
            anchorEl: this.state.anchorEl,
            dataList: this.state.anchorData
          })
        ),
        _react2.default.createElement(
          'svg',
          { ref: this.svg2, width: outerWidth, height: OUTER_HEIGHT2 },
          _react2.default.createElement(
            'g',
            {
              className: 'context',
              transform: 'translate(' + margin2.left + ', ' + margin2.top + ')'
            },
            _react2.default.createElement('g', { className: 'brush', ref: this.brushRef }),
            _react2.default.createElement('g', { ref: this.x2AxisRef, transform: 'translate(0, ' + height2 + ')' })
          )
        )
      );
    }
  }, {
    key: '_outerWidth',
    value: function _outerWidth() {
      return this.props.contentRect.bounds.width;
    }
  }, {
    key: '_render',
    value: function _render(handleMouseOver) {
      var _this2 = this;

      var associations = this.props.associations;

      var assocs = associations;

      var outerWidth = this._outerWidth();

      if (outerWidth === undefined) return;

      var width = outerWidth - margin.left - margin.right;

      this.x.range([0, width]);
      this.x2.range([0, width]);
      this.y.domain([0, d3.max(assocs, function (d) {
        return -Math.log10(d.pval);
      }) || 0]);
      this.y2.domain([0, d3.max(assocs, function (d) {
        return -Math.log10(d.pval);
      })]);

      var svg = d3.select(this.svg.current);
      var svg2 = d3.select(this.svg2.current);
      var focus = svg.select('.focus');
      var context = svg2.select('.context');
      d3.select(this.clip.current).attr('width', width);
      d3.select(this.sigLine.current).attr('y1', this.y(_utils.SIGNIFICANCE)).attr('x2', width).attr('y2', this.y(_utils.SIGNIFICANCE));

      var bars = focus.selectAll('rect').data(assocs);
      var bars2 = context.selectAll('rect').data(assocs);

      bars.enter().append('rect').style('cursor', 'auto').attr('width', 2).attr('fill', _theme2.default.line.color).attr('x', function (d) {
        return _this2.x(d.globalPosition);
      }).attr('y', function (d) {
        return _this2.y(-Math.log10(d.pval));
      }).attr('height', function (d) {
        return _this2.y(0) - _this2.y(-Math.log10(d.pval));
      }).on('mouseover', function (d) {
        handleMouseOver(this, d);
      });

      bars.exit().remove();

      d3.select(this.yAxisRef.current).call(customYAxis, this.yAxis);

      bars2.enter().append('rect').attr('width', 2).attr('fill', _theme2.default.line.color).attr('y', function (d) {
        return _this2.y2(-Math.log10(d.pval));
      }).attr('height', function (d) {
        return _this2.y2(0) - _this2.y2(-Math.log10(d.pval));
      }).merge(bars2).attr('x', function (d) {
        return _this2.x2(d.globalPosition);
      });

      bars2.exit().remove();

      d3.select(this.x2AxisRef.current).call(customXAxis, this.x2Axis);

      this.brush.extent([[0, 0], [width, height2]]);

      this.zoom.translateExtent([[0, 0], [width, height]]).extent([[0, 0], [width, height]]);

      d3.select(this.brushRef.current).call(this.brush).call(this.brush.move, this.x.range());

      d3.select(this.svg.current).call(this.zoom);
    }
  }]);

  return ManhattanPlot;
}(_react.Component);

exports.default = (0, _reactMeasure.withContentRect)('bounds')(ManhattanPlot);